import React from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const onConfirmCompanyservice = hooks.useGlobalFormFunction('companyservice_form', 'requestSubmit')

  const mergedProps = {
    onConfirmCompanyservice

  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
